import * as React from 'react';
import clsx from 'clsx';
import {
  createStyles,
  makeStyles,
  useTheme,
  Theme,
  MuiThemeProvider
} from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import './CSAllStatus.scss';
import i18n from 'src/translation/i18n';

import iObjCSService from 'src/services/claimStatus/claimStatusService';
// });

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      maxWidth: 300
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    chip: {
      margin: 2
    },
    noLabel: {
      marginTop: theme.spacing(3)
    }
  })
);

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
     // maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 'auto',
      minWidth: '150px'
    }
  }
};

export default function CSAllStatus(props: any) {
  const classes = useStyles();
  const theme = useTheme();
  const allCStatusVal = [
    {
      claimStatus: i18n.t('claimStatus.cSubmitted'),
      value: 'SC'
    },
    {
      claimStatus: i18n.t('claimStatus.cInprogress'),
      value: 'IC'
    },
    {
      claimStatus: i18n.t('claimStatus.cApproved'),
      value: 'AC'
    },
    {
      claimStatus: i18n.t('claimStatus.cPartiallyApproved'),
      value: 'PC'
    },
    {
      claimStatus: i18n.t('claimStatus.cRejected'),
      value: 'RC'
    }
  ];
  const [personName, setPersonName] = React.useState<string[]>([]);
  const [allCStatus, setAllCStatus] = React.useState([]);

  const { isReset, filter, cStatusSearch } = props;
  const [apiLoader, handleApiLoader] = React.useState(false);

  React.useEffect(() => {
    if (allCStatus.length === 0) {
      handleApiLoader(true);
      iObjCSService
        .gClaimStatusLookupData()
        .then((response: any) => {
          // console.log(response);
          const resData = response;
          setAllCStatus(resData);
        })
        .catch((error: any) => {
          handleApiLoader(false);
          setAllCStatus([]);
        });
    }
  }, []);

  React.useEffect(() => {
    if (isReset) {
      setPersonName([]);
    }
  }, [isReset]);

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setPersonName(event.target.value as string[]);
    filter(event.target.value);
  };

  const gClaimStatusMenuItem = (val: any, index: number) => {
    return (
      <MenuItem
        key={index}
        value={index === 0 ? '' : val.claimStatus}
        className="invoices-dropdown"
      >
        {val.claimStatus}
      </MenuItem>
    );
  };
  const { getInvoices } = props;
  return (
    <div className="Invoicefilter-container CStatusfilter-container nopaddingl0 csFilter2  col-md-4 col-sm-6 col-lg-2 col-xs-12">
      <MuiThemeProvider theme={theme}>
        <FormControl className={clsx(classes.formControl, classes.noLabel)}>
          <Select
            displayEmpty={true}
            value={personName}
            onChange={handleChange}
            MenuProps={MenuProps}
            inputProps={{ 'aria-label': 'Without label' }}
          >
            {allCStatus &&
              allCStatus.length > 0 &&
              allCStatus.map((val: any, index: number) =>
                gClaimStatusMenuItem(val, index)
              )}
            {/* <MenuItem value={'process'}>In-process</MenuItem> */}
          </Select>
        </FormControl>
      </MuiThemeProvider>
    </div>
  );
}
